import { Controller } from "@hotwired/stimulus"

// Spinner sur le bouton de la modale de confirmation, dès le clic — sans
// attendre la réponse serveur.
export default class extends Controller {
  busy() {
    this.element.setAttribute("aria-busy", "true")
    this.element.setAttribute("aria-disabled", "true")
  }
}
